import React, { useContext, useState } from 'react';
import FetchApi from '../api/getAxios';
import { useUserContext } from './user_context';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useLocalStorage } from '../utils/useLocalStorage';
import { decrypt, encrypt } from '../encrypt';


export const AuthContext = React.createContext();


export const AuthProvider = ({ children }) => {

    const [bizLoad, setBizLoad] = useState(false);
    const [allBusiness, setallBusiness] = useState([]);
    const [storeLoad, setStoreLoad] = useState(false);
    const [allStores, setallStores] = useState([]);

    const [bizData, setBizData] = useLocalStorage('businessData');
    const [storedata, setStoreData] = useLocalStorage('storeData');
    const [featureaccess, setFeatureAccess] = useLocalStorage('featureAccess');


    const { usertoken } = useUserContext();

    let businessData = decrypt(bizData);
    let storeData = decrypt(storedata?.storeData);
    let featureAccess = decrypt(featureaccess);

    const navigate = useNavigate();

    // Check Access
    const checkFeature = (feature) => {
        const data = featureAccess?.data?.findIndex(x => x === feature);
        if (data >= 0) {
            return true;
        } else {
            return false;
        }
    };
    // Check Access




    // Get All Businesses
    const getAllBusiness = async () => {
        setBizLoad(true);
        const data = {
            usertoken,
        };
        FetchApi.post(`/getUserBusiness`, data)
            .then((res) => {

                if (res.success === false) {
                    setBizLoad(false);
                    toast.warn(res.message);
                } else {
                    if (res.data === false) {
                        setBizLoad(false);
                        setallBusiness([]);
                        navigate("/create-business");
                        setTimeout(() => {
                            toast.warn("You need to Create a Business Profile");
                        }, 10);
                    } else {
                        setBizLoad(false);
                        setallBusiness(res.data);
                    }
                }
            })
            .catch(() => {
                setBizLoad(false);
            });
    };
    // Get All Businesses

    // Get All Store
    const getAllStore = async (btoken) => {
        setStoreLoad(true);
        const data = {
            btoken
        };
        FetchApi.post(`/getBusinessStores`, data)
            .then((res) => {
                if (res.success === false) {
                    setStoreLoad(false);
                    toast.warn(res.message);
                } else {
                    setStoreLoad(false);
                    setallStores(res.data);
                }
            })
            .catch(() => {
                setStoreLoad(false);
            });
    };
    // Get All Store

    // Get Business Data
    const getBusinessData = async (btoken) => {
        const data = {
            btoken, usertoken
        };
        FetchApi.post(`/getBusinessData`, data)
            .then((res) => {
                if (res.success === false) {
                } else {
                    setBizData(encrypt(res.data));
                }
            })
            .catch(() => {
                return;
            });
    };
    // Get Business Data

    // Get Store Data
    const getStoreData = async (stoken, btoken) => {
        const data = {
            btoken, stoken, usertoken
        };
        FetchApi.post(`/getStoreData`, data)
            .then((res) => {
                if (res.success === false) {
                } else {
                    setStoreData(encrypt(res.data));
                }
            })
            .catch(() => {
                return;
            });
    };
    // Get Store Data

    // Get User Feature Access
    function getFeatureAccess(e, btoken, setstoken) {
        setstoken(e);
        getStoreData(e, btoken);
        const data = {
            btoken, usertoken
        };
        FetchApi.post(`/user.access.get`, data)
            .then((res) => {
                if (res.success === false) {
                } else {
                    setFeatureAccess(encrypt(res.data));
                    getBusinessData(btoken);
                }
            })
            .catch((error) => {
                return;
            });
    }
    // Get User Feature Access

    return (
        <AuthContext.Provider value={{
            getBiz: { getAllBusiness, allBusiness, bizLoad, getBusinessData, businessData },
            getStore: { getAllStore, allStores, storeLoad, getStoreData, storeData },
            getFeature: { getFeatureAccess, featureAccess, checkFeature }

        }}>
            {children}
        </AuthContext.Provider>
    );
};

// make sure use
export const useAuthContext = () => {
    return useContext(AuthContext);
};
